import { Card, CardContent, CardHeader, CardTitle } from "@/ui/base/card";
import { cn } from "@/nucleo/utilitarios";

interface DashboardCardProps {
  title: string;
  subtitle?: string;
  icon?: React.ComponentType<{ className?: string }>;
  iconClassName?: string;
  className?: string;
  children: React.ReactNode;
}

export function DashboardCard({
  title,
  subtitle,
  icon: Icon,
  iconClassName,
  className,
  children,
}: DashboardCardProps) {
  return (
    <Card className={cn("rounded-2xl border border-border/60 overflow-hidden", className)}>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2.5">
          {Icon && (
            <div className="rounded-lg bg-orange/10 p-1.5">
              <Icon className={cn("h-4 w-4 text-orange", iconClassName)} />
            </div>
          )}
          <div className="min-w-0">
            <CardTitle className="text-sm font-bold">{title}</CardTitle>
            {subtitle && <p className="text-[11px] text-muted-foreground">{subtitle}</p>}
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">{children}</CardContent>
    </Card>
  );
}
